import React from "react";
import { withRouter } from 'react-router-dom';
import UpsellEcCard from './upsell-Ec-Card';

const UpsellEcHeader = (props) => {

  const {header,card,history} = props;
  const goBack = () => {
    history.push(`paiement`)
  }
  
  return(
    <section className="upsellEc-headingSection">
      <div className="upsellEc-headingSection-wrapper">
        <div className="goBackLink-container">
          <a className="goBackLink" style={{cursor: "pointer"}} onClick={goBack}>
          <i className="icn-arrow-left"></i>Retour
        </a>
        </div>
        <div className="upsellEc-header">
          <h1 className="upsellEc-headerTitle">{header.headerTitle}</h1>
          <img alt="" className="upsellEc-headerImage" src={header.headerImage}/>
        </div>
        <p className="upsellEc-headerText">{header.headerText}</p>
        <UpsellEcCard card={card} />
      </div>
    </section>
  )
}
export default withRouter (UpsellEcHeader);



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec-Header.js